var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 8.4 10)",
    id: "05s3v_g5xF16OXpJ6qXni"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(107,70,236)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-8.4, -10)",
    d: "M 8.04722 0.00534014 C 7.31949 0.0885288 6.86214 0.217219 6.32039 0.491226 C 5.80302 0.752905 5.45106 1.01142 5.05192 1.42293 C 4.36493 2.1312 3.94443 2.98351 3.78021 4.00043 C 3.75134 4.17925 3.74642 4.43788 3.74025 6.10429 L 3.73323 8.00427 L 2.06583 8.00427 L 0.398438 8.00427 L 0.398438 14.0021 L 0.398438 20 L 8.39844 20 L 16.3984 20 L 16.3984 14.0021 L 16.3984 8.00427 L 14.7311 8.00427 L 13.0638 8.00427 L 13.0568 6.10429 C 13.0491 4.0152 13.0524 4.07795 12.9232 3.55248 C 12.8373 3.20304 12.7468 2.95404 12.5849 2.62182 C 12.3513 2.14273 12.1059 1.79464 11.7261 1.4037 C 11.0105 0.667235 10.1114 0.206845 9.06765 0.042441 C 8.88618 0.0138583 8.19311 -0.0113445 8.04722 0.00534014 Z M 8.98084 1.38237 C 10.1598 1.58419 11.168 2.45257 11.5499 3.59519 C 11.7278 4.12763 11.738 4.28186 11.7309 6.33385 L 11.7253 7.9945 L 8.39844 7.9945 L 5.07161 7.9945 L 5.06593 6.33385 C 5.06002 4.60731 5.06907 4.31978 5.13994 3.98304 C 5.44136 2.55121 6.61947 1.49629 8.08897 1.34236 C 8.31495 1.31868 8.71313 1.33655 8.98084 1.38237 Z M 15.0521 14.0021 L 15.0521 18.6715 L 8.39844 18.6715 L 1.74478 18.6715 L 1.74478 14.0021 L 1.74478 9.33278 L 8.39844 9.33278 L 15.0521 9.33278 L 15.0521 14.0021 Z M 8.21307 11.3451 C 8.04954 11.3698 7.94691 11.4038 7.7838 11.4874 C 7.57561 11.5943 7.32556 11.841 7.22133 12.0426 C 6.96454 12.539 7.04101 13.1461 7.41067 13.5458 C 7.48049 13.6213 7.58179 13.7131 7.6358 13.7498 L 7.73401 13.8165 L 7.73452 15.2379 L 7.73502 16.6592 L 8.39844 16.6592 L 9.06185 16.6592 L 9.06236 15.2379 L 9.06287 13.8165 L 9.16107 13.7498 C 9.40441 13.5845 9.62706 13.2579 9.69504 12.9667 C 9.73307 12.8038 9.73299 12.5234 9.69491 12.361 C 9.54008 11.701 8.87545 11.2454 8.21307 11.3451 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockPurple);
export default __webpack_public_path__ + "static/media/lock_purple.e2f25ebe239aa18ca0a5c0bb2dddeeda.svg";
export { ForwardRef as ReactComponent };